import { lang } from '@umu/ukit-lang';
/**
 * @desc 微信关注引导
 * @author Kody
 * @dete 2019-11-19
 */
import React from 'react';
import umuWebview from '@umu/umu-webview';
import { components } from 'common';
const { PreImg } = components;

interface IProps {
    className?: string;
    wxInfo: {
        is_follower: number; // 是否关注了微信公众号
        scene_url: string; // 关注二维码
    };
    children?: JSX.Element;
}

import './wechatSubscribe.scss';

export const WechatSubscribe = (props: IProps) => {
    const { wxInfo, className = '' } = props;
    const isSubscribe = wxInfo.is_follower;
    const followUrl = wxInfo.scene_url;
    const renderText = () => {
        return (
            <div className={`tips ${className}`}>
                <p className="desc">{lang('长按图片识别二维码')}</p>
                <p className="desc">{lang('关注后获取更多信息')}</p>
            </div>
        );
    };
    const render = () => {
        if (isSubscribe || !followUrl || umuWebview.UA_INFO.isUMUWebview) {
            return null;
        }
        return (
            <div className="wechat-subscribe">
                <PreImg>
                    <img src={followUrl} alt="" />
                </PreImg>
                {props.children || renderText()}
            </div>
        );
    };
    return render();
};
